import { getCurrentInstance, ref, Ref } from 'vue';

export interface I18nComposable {
    t: (key: string, ...args: any[]) => any;
    locale: Ref<string> | string;
}

export function useI18n(): I18nComposable {
    const instance = getCurrentInstance();

    if (!instance) {
        console.warn(
            `[useI18n] was called outside of a component setup function. ` + `I18n features will not be available.`,
        );
        return {
            t: (key: string) => key,
            locale: ref('ru'),
        };
    }

    const i18n = instance.proxy.$i18n;

    if (!i18n) {
        throw new Error(
            `[useI18n] Could not find $i18n instance. ` + `Please check if the vue-i18n plugin is properly installed.`,
        );
    }

    const t = i18n.t.bind(i18n);
    const locale = i18n.locale;

    return {
        t,
        locale,
    };
}
